/**
 * Language: Czech (Čeština).
 */
export default {
    time: {
        openingHoursTitle: "Otevírací doba",
        at: "v",
	to: "do",
        opensToday: "Otevřeno dnes",
        opens: "Otevírá",
        open24_7: "Otevřeno 24/7",
        closed: "Zavřeno",
        openUntil: "Otevřeno do",
        daily: "Denně otevřeno",
        month: [
            'Ledna', 'Února', 'Března', 'Dubna', 'Května', 'Června',
            'Července', 'Srpna', 'Září', 'Října', 'Listopadu', 'Prosince'
        ],
        monthAbbr: [
            'Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čer',
            'Čec', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro'
        ],
        dayOfWeek: [
            'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota', 'Neděle', 
        ],
        dayOfWeekAbbr: [
            'Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne', 
        ],
        temporarilyClosed: "Dočasně uzavřeno",
	opened: "",
        today: ""
    },
    search: {
        placeholder: "Ulice, město nebo PSČ",
        submitLabel: "Vyhledat",
        clearLabel: "Smazat vyhledávání",
        yourLocation: "Tvoje poloha",
    },
    filtering: {
        servicesTitle: "Služby",
        services: {
            WF: 'WiFi připojení',
            CD: 'Mobilní platby',
            DT: 'Drive-Thru',
            DR: 'Digitální odměny',
            hrs24: 'Otevřeno 24 hodin denně',
            WA: 'Ohřáté jídlo',
            LB: 'LaBoulange',
            XO: 'Objednání a platba mobilní aplikací',
            VS: 'Verismo',
            NB: 'Nitro Cold Brew',
            CL: 'Starbucks Reserve-Clover Brewed',
        }
    },
    stores: {
        cta: {
            call: "Zavolat",
            directions: "Navigovat",
            website: "Webové stránky",
            'club details': 'Club details',
            'view tariffs': 'Join now',
	'View Map': "Ukázat mapu",
            'View List': "Ukázat seznam"
        },
        messages: {
            initialHeader: "Hledejte podle adresy, abyste zobrazili kluby, které se nacházejí poblíž",
            emptyHeader: "Nenalezen žádný klub",
            initialBody: "nebo klikněte na mapu pro výběr klubu",
            emptyBody: "Prosím, hledejte jinou lokalitu nebo zrušte vybrané filtry"
        }
    },
    directions: {
        avoidOptions: {
            highways: 'Dálnice',
            tolls: 'Mýtné',
            ferries: 'Přívozy'
        },
        unitOptions: {
            METRIC: 'km',
            IMPERIAL: 'míle'
        },
        options: "Možnosti trasy",
        avoid: "Vyhnout se",
        units: "Jednotky vzdálenosti",
        messages: {
            initialBody: "Vyhledejte počáteční a cílový bod, abyste viděli dostupné trasy a dobu cesty.",
            error: "Omlouváme se, nepodařilo se spočítat směrování",
            from: "z",
            to: "do",
            forTravelMode: "pro zvolený způsob přepravy",
            via: "přes",
            details: "Podrobnosti",
            withoutTraffic: "bez dopravy",
            openGoogleMaps: "otevřít v Google Maps"
        }
    },
    errors: {
        loadingLibrary: "nepodařilo se načíst knihovnu {library}",
        geolocationFailed: "Poloha uživatele se nepodařila získat",
        apiErrors:{
            "401": "Neautorizováno",
            "403": "Zakázáno",
            "429": "Příliš mnoho požadavků",
            "500": "Interní chyba serveru",
            other: "Nastala neočekávaná chyba serveru"
        }
    },
};
